<div class="accordion-body-content">
  <ng-content></ng-content>
</div>
